import { combineReducers, configureStore } from "@reduxjs/toolkit";
import appSlice from "./appSlice";
import originSlice from "./originSlice";
import configurationSlice from "./configurationSlice";
import {
    configServersReducer,
    configPlugInReducer,
    configASOPluginReducer,
    configDocumentBundlesReducer,
    configEventBundlesReducer,
    configDocumentMappingReducer,
    configPushbackReducer,
    configXPathFieldMapReducer,
    pushbackLoansReducer,
    pushbackOrderDetailsReducer,
    pushbackDetailReducer,
    pushbackReportReducer,
    pushbackClientLogsReducer,
    xPathDataReducer
} from "./configReducers";
import importPluginConfigReducer from './slices/importPluginConfigSlice';
import integrationSlice from './slices/importIntegrationSlice';
import importPushbackSlice from './slices/importPushbackSlice';
import xpathFieldMapSlice from './slices/importXpathFieldMapSlice';
import importBundlingSlice from './slices/importBundlingSlice';
import importEventBundlingSlice from './slices/importEventBundlingSlice';
import importDocumentMappingSlice from "./slices/importDocumentMappingSlice";
import expressionValidationSlice from "./slices/importExpressionValidationSlice";
import tpoErrorReducer from './configReducers/tpoErrorReducer';

const reducer = combineReducers({
    appSlice,
    originSlice,
    configuration: configurationSlice,
    configServers: configServersReducer,
    configPlugInData: configPlugInReducer,
    configASOPluginData: configASOPluginReducer,
    tpoError: tpoErrorReducer, // Add TPO error reducer
    configDocumentBundles: configDocumentBundlesReducer,
    configEventBundles: configEventBundlesReducer,
    configDocumentMapping: configDocumentMappingReducer,
    configPushbackDefaults: configPushbackReducer,
    configXPathFieldMap: configXPathFieldMapReducer,
    importPluginConfig: importPluginConfigReducer,
    importIntegration: integrationSlice,
    importPushback: importPushbackSlice,
    importXpathFieldMap: xpathFieldMapSlice,
    importDocumentMapping: importDocumentMappingSlice,
    importBundling: importBundlingSlice,
    importEventBundling: importEventBundlingSlice,
    pushbackLoans: pushbackLoansReducer,
    pushbackOrderDetails: pushbackOrderDetailsReducer,
    pushbackDetail: pushbackDetailReducer,
    pushbackReport: pushbackReportReducer,
    pushbackClientLogs: pushbackClientLogsReducer,
    xPathData: xPathDataReducer,
    expressionValidationData: expressionValidationSlice
})

export const store = configureStore({
    reducer
})

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = AppStore['dispatch'];